import { render, staticRenderFns } from "./TenderQueryAccordion.vue?vue&type=template&id=56e4f7ce&scoped=true&"
import script from "./TenderQueryAccordion.vue?vue&type=script&lang=js&"
export * from "./TenderQueryAccordion.vue?vue&type=script&lang=js&"
import style0 from "./TenderQueryAccordion.vue?vue&type=style&index=0&id=56e4f7ce&lang=scss&scoped=true&"
import style1 from "./TenderQueryAccordion.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e4f7ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56e4f7ce')) {
      api.createRecord('56e4f7ce', component.options)
    } else {
      api.reload('56e4f7ce', component.options)
    }
    module.hot.accept("./TenderQueryAccordion.vue?vue&type=template&id=56e4f7ce&scoped=true&", function () {
      api.rerender('56e4f7ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/queries/TenderQueryAccordion.vue"
export default component.exports